<template>
    <v-row justify="center">
        <v-card class="mt-16">
            <v-card-text v-html="tHtml(message)" data-cy="error-message"></v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn :href="`mailto:${email}`" class="mt-0 myprovet-btn-ok" data-cy="submit-button">Contactar suporte</v-btn>
                <v-btn href="/" class="mt-0 myprovet-btn-ok" data-cy="home-button">Página inicial</v-btn>
            </v-card-actions>
        </v-card>
    </v-row>
</template>

<script>
import { useUserStore } from '@/Stores/user';
import { mapStores } from 'pinia';

export default {
    props: {
        message: String,
        email: String,
        redirect: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapStores(useUserStore),
    },
    mounted() {
        this.userStore.logout(this.$inertia, this.$tawkMessenger, true);

        if (this.redirect) {
            setTimeout(() => {
                this.$inertia.visit('/');
            }, 10000);
        }
    },
};
</script>

<style scoped></style>
